import { useState } from 'react'
import { Icon } from '@leroy-merlin-br/backyard-react'

import { useResize } from 'scripts/react-components/utils/hooks/use-resize'

import { ChatModal, Tooltip, Icons } from './Components'
import * as S from './styled'

const Chat = () => {
  const [isMobile] = useResize()
  const [chatIsOpen, setChatIsOpen] = useState(false)

  if (isMobile) {
    return null
  }

  return (
    <S.ChatButtonWrapper data-testid="chat-button-wrapper">
      <ChatModal
        isOpen={chatIsOpen}
        onClose={() => {
          setChatIsOpen(false)
        }}
        onHide={() => {
          setChatIsOpen(false)
        }}
      />
      {!chatIsOpen && (
        <Tooltip data-testid="chat-tooltip-wrapper">
          <S.ChatButton
            data-testid="chat-button-caller"
            onClick={() => setChatIsOpen(true)}
          >
            <Icon size="peta" role="presentation" as={Icons.ChatTyping} />
          </S.ChatButton>
        </Tooltip>
      )}
    </S.ChatButtonWrapper>
  )
}

export default Chat
